__turbopack_context__.v({
  "embedFrame": "VideoPlayer-module__AI35cW__embedFrame",
  "errorBox": "VideoPlayer-module__AI35cW__errorBox",
  "haber-plyr-spin": "VideoPlayer-module__AI35cW__haber-plyr-spin",
  "loading": "VideoPlayer-module__AI35cW__loading",
  "loadingSpinner": "VideoPlayer-module__AI35cW__loadingSpinner",
  "mount": "VideoPlayer-module__AI35cW__mount",
  "nativeVideo": "VideoPlayer-module__AI35cW__nativeVideo",
  "shell": "VideoPlayer-module__AI35cW__shell",
  "shellTall": "VideoPlayer-module__AI35cW__shellTall",
});
